import React from 'react';
import { Button } from '@material-ui/core';
import { useTranslate } from 'react-admin';

interface ControlPanelProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onAutoFit: () => void;
  onRotateLeftMouseDown: () => void;
  onRotateRightMouseDown: () => void;
  onRotateMouseUp: () => void;
  onResetRotation: () => void;
}

export const ControlPanel: React.FC<ControlPanelProps> = ({
  onZoomIn,
  onZoomOut,
  onAutoFit,
  onRotateLeftMouseDown,
  onRotateRightMouseDown,
  onRotateMouseUp,
  onResetRotation
}) => {
  const translate = useTranslate();
  const buttonStyle: React.CSSProperties = {
    minWidth: '40px',
    width: '40px',
    height: '40px',
    fontSize: '16px',
    fontWeight: 'bold',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>
      {/* Zoom controls row */}
      <div style={{ display: 'flex', gap: '5px' }}>
        <Button onClick={onZoomOut} style={buttonStyle} variant="outlined" color="secondary">
          −
        </Button>
        <Button onClick={onAutoFit} style={buttonStyle} variant="outlined" color="secondary">
          ⌂
        </Button>
        <Button onClick={onZoomIn} style={buttonStyle} variant="outlined" color="secondary">
          +
        </Button>
      </div>

      {/* Rotation controls row */}
      <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
        <Button
          onMouseDown={onRotateLeftMouseDown}
          onMouseUp={onRotateMouseUp}
          onMouseLeave={onRotateMouseUp}
          style={buttonStyle}
          title={translate('osfc.storage_ui.controls.rotate_left')}
          variant="outlined"
          color="secondary"
        >
          ↶
        </Button>
        <Button onClick={onResetRotation} style={buttonStyle} title={translate('osfc.storage_ui.controls.reset_rotation')} variant="outlined" color="secondary">
          ⊙
        </Button>
        <Button
          onMouseDown={onRotateRightMouseDown}
          onMouseUp={onRotateMouseUp}
          onMouseLeave={onRotateMouseUp}
          style={buttonStyle}
          title={translate('osfc.storage_ui.controls.rotate_right')}
          variant="outlined"
          color="secondary"
        >
          ↷
        </Button>
      </div>
    </div>
  );
};
